import React from "react";
import { Logo } from "../components/kit";

export default function AuthLayout({ title, subtitle, children, testId }) {
  return (
    <div
      data-testid={testId}
      style={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        background: "var(--surface-page)",
      }}
      className="buktu-auth-layout"
    >
      {/* Brand panel */}
      <div
        data-surface="deep"
        style={{
          background: "var(--buktu-green-dark)",
          padding: "var(--space-16) var(--space-12)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        className="buktu-auth-brand"
      >
        <Logo height={30} reverse />
        <div>
          <h2 style={{ font: "var(--type-display)", fontSize: "clamp(28px,3vw,39px)", letterSpacing: "var(--tracking-tight)", color: "#fff", maxWidth: 420 }}>
            One clear, honest picture of how your business is actually doing.
          </h2>
          <p style={{ font: "var(--type-body)", color: "var(--text-muted)", marginTop: "var(--space-4)", maxWidth: 380 }}>
            No spreadsheets. No guessing. Fifteen seconds a day.
          </p>
        </div>
        <span style={{ font: "var(--type-body-sm)", fontSize: 12, color: "var(--text-faint)" }}>© 2026 Buktu</span>
      </div>

      {/* Form panel */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "var(--space-12) var(--page-gutter)" }}>
        <div style={{ width: "100%", maxWidth: 400 }} className="buktu-rise">
          <div className="buktu-auth-mobile-logo" style={{ display: "none", marginBottom: "var(--space-8)" }}>
            <Logo height={30} />
          </div>
          <h1 style={{ font: "var(--type-title)", letterSpacing: "var(--tracking-snug)", marginBottom: "var(--space-2)" }}>{title}</h1>
          {subtitle && <p style={{ font: "var(--type-body)", color: "var(--text-muted)", marginBottom: "var(--space-6)" }}>{subtitle}</p>}
          {children}
        </div>
      </div>

      <style>{`
        @media (max-width: 860px) {
          .buktu-auth-layout { grid-template-columns: 1fr !important; }
          .buktu-auth-brand { display: none !important; }
          .buktu-auth-mobile-logo { display: block !important; }
        }
      `}</style>
    </div>
  );
}
